var domains = {
    url: '/api',
    media: "https://".concat(process.env.REACT_APP_DEBUG ? 'dev-' : '', "media.ayomi.fr"),
};
export default domains;
